import { render, staticRenderFns } from "./SummaryItem.vue?vue&type=template&id=d4796e4a"
import script from "./SummaryItem.vue?vue&type=script&lang=js"
export * from "./SummaryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports